var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaster({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.678,
    height: 18.68,
    viewBox: "0 0 15.678 18.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.777 5.39h-5.59a.962.962 0 0 1-.962-.962V2.962A.962.962 0 0 1 11.187 2h5.59a.962.962 0 0 1 .962.962v1.466a.962.962 0 0 1-.962.962z",
    transform: "translate(-6.114 -2)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.315 4.61H16.5v.731a1.939 1.939 0 0 1-1.937 1.937h-5.59a1.939 1.939 0 0 1-1.937-1.937V4.61h-.809A2.324 2.324 0 0 0 3.9 6.937v11.849a2.324 2.324 0 0 0 2.327 2.327H17.3a2.324 2.324 0 0 0 2.327-2.327V6.937a2.309 2.309 0 0 0-2.312-2.327zm-6.559 9.641h-2.82a.585.585 0 0 1 0-1.17h2.82a.585.585 0 1 1 0 1.17zm3.453-3.32H7.936a.585.585 0 1 1 0-1.17h6.271a.585.585 0 0 1 0 1.17z",
    transform: "translate(-3.9 -2.914)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaster);
export default __webpack_public_path__ + "static/media/master.03b7d305f4b4abd313f22f8c1d338baf.svg";
export { ForwardRef as ReactComponent };